"use client"

import { useMemo } from "react"

interface UseUserFilteringProps {
  myUsers: any[]
  historyUsers?: any[] 
  usersWithHistory: Set<string>
  searchQuery: string
  sortOrder: "asc" | "desc"
  isHistoryPage?: boolean
}

export const useUserFiltering = ({ 
  myUsers, 
  historyUsers = [],
  usersWithHistory, 
  searchQuery, 
  sortOrder,
  isHistoryPage = false
}: UseUserFilteringProps) => {
  const filteredAndSortedUsers = useMemo(() => {
    const usersToFilter = isHistoryPage && historyUsers.length > 0
      ? historyUsers 
      : isHistoryPage 
        ? [] 
        : myUsers.filter(user => usersWithHistory.has(String(user.id)));

    const filtered = usersToFilter.filter(user => {
      if (!searchQuery.trim()) return true
      
      const query = searchQuery.toLowerCase()
      
      if (isHistoryPage) {
        const name = (user.name || "").toLowerCase()
        const phone = (user.phone || "").toLowerCase()
        
        return name.includes(query) || phone.includes(query)
      } else {
        const displayName = (user.displayName || user.name || "").toLowerCase()
        const phone = (user.phone || "").toLowerCase()
        
        return displayName.includes(query) || phone.includes(query)
      }
    })

    const usersWithName: any[] = []
    const usersWithoutName: any[] = []
    
    filtered.forEach(user => {
      if (isHistoryPage) {
        if (user.name && user.name !== "null" && String(user.name).trim() !== "") {
          usersWithName.push(user)
        } else {
          usersWithoutName.push(user)
        }
      } else {
        const displayName = user.displayName || user.name
        if (displayName && displayName !== "null" && String(displayName).trim() !== "") {
          usersWithName.push(user)
        } else {
          usersWithoutName.push(user)
        }
      }
    })

    const sortFunction = (a: any, b: any) => {
      let aValue: string, bValue: string
      
      if (isHistoryPage) {
        aValue = a.name || a.phone || ""
        bValue = b.name || b.phone || ""
      } else {
        aValue = a.displayName || a.name || a.phone || ""
        bValue = b.displayName || b.name || b.phone || ""
      }
      
      const comparison = aValue.localeCompare(bValue)
      return sortOrder === "asc" ? comparison : -comparison
    }

    const sortedWithName = usersWithName.sort(sortFunction)
    const sortedWithoutName = usersWithoutName.sort(sortFunction)

    return [...sortedWithName, ...sortedWithoutName]
  }, [myUsers, historyUsers, usersWithHistory, searchQuery, sortOrder, isHistoryPage])

  return { filteredAndSortedUsers }
}
